// extracted by mini-css-extract-plugin
module.exports = {"container":"AcxToken_container__1ExmM","wrapper":"AcxToken_wrapper__283nP"};